import { render, staticRenderFns } from "./AddressForm.vue?vue&type=template&id=6f63a7c6&scoped=true"
import script from "./AddressForm.vue?vue&type=script&lang=js"
export * from "./AddressForm.vue?vue&type=script&lang=js"
import style0 from "./AddressForm.vue?vue&type=style&index=0&id=6f63a7c6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f63a7c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f63a7c6')) {
      api.createRecord('6f63a7c6', component.options)
    } else {
      api.reload('6f63a7c6', component.options)
    }
    module.hot.accept("./AddressForm.vue?vue&type=template&id=6f63a7c6&scoped=true", function () {
      api.rerender('6f63a7c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/AddressForm.vue"
export default component.exports